import React, { h, Component } from 'preact';;
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import util from "../util";
import MenuObject from "../canvas/menu-object";
import constants from "../constants";

export default @connect(reduce, actions)
class AsideMenuObjectSpacing extends Component {
  constructor() {
    super()

    this.updateMOSpacing = this.updateMOSpacing.bind(this);
  }

  updateMOSpacing(ev, key, attr, decimal, divide = true) {
    let value = divide ? parseFloat(ev.target.value) / 10 : parseFloat(ev.target.value);
    if (this.props.menuObjectStyles[key] && this.props.menuObjectStyles[key][attr]) {
      const current = (parseFloat(this.props.menuObjectStyles[key][attr])).toFixed(decimal);
      if (value.toFixed(decimal) === current) return;
    }
    this.update(key, attr, `${value}em`);

    if (key === 'name' && attr === 'letter-spacing') {
      this.update('bin', attr, `${value}em`);
    }

    if (key === 'price-entry' && attr === 'margin-right') {
      this.update('price-entry:not(.last)::after', 'right', `-${value}em`);
      this.update('price-entry:not(.last)::after', 'width', `${value}em`);
    }
  }

  update(type, key, value) {
    const menuObjects = this.props.$elements.filter(it => it.attr('data-component') === 'menu-object');
    MenuObject.patchStyles(this.props.isMultiSelect ? menuObjects : this.props.$element, { type, key, value });
  }

  applyToAll() {
    window.ConfirmationModal.show({
      title: 'Are you sure?',
      body: 'This will apply the current spacing to the entire menu.',
      acceptLabel: 'Yes, apply to all',
      declineLabel: 'Cancel',
      onAccept: () => {
        MenuObject.applyToAll(this.props.$element, MenuObject.applyModes.itemSpacing);
      },
      onDecline: () => {
        window.ConfirmationModal.hide()
      }
    });
  };

  namesApplyToAll() {
    window.ConfirmationModal.show({
      title: 'Are you sure?',
      body: 'This will apply the current group name spacing to the entire menu.',
      acceptLabel: 'Yes, apply to all',
      declineLabel: 'Cancel',
      onAccept: () => {
        MenuObject.applyToAll(this.props.$element, MenuObject.applyModes.nameSpacing);
      },
      onDecline: () => {
        window.ConfirmationModal.hide()
      }
    });
  };

  notesApplyToAll() {
    window.ConfirmationModal.show({
      title: 'Are you sure?',
      body: 'This will apply the current group notes spacing to the entire menu.',
      acceptLabel: 'Yes, apply to all',
      declineLabel: 'Cancel',
      onAccept: () => {
        MenuObject.applyToAll(this.props.$element, MenuObject.applyModes.notesSpacing);
      },
      onDecline: () => {
        window.ConfirmationModal.hide()
      }
    });
  };

  render(props, state) {
    let nameLineHeight = 0;
    let nameLetterSpacing = 0;
    let binLineHeight = 0;
    let itemMarginBottom = 0;
    let itemLineHeight = 10;
    let moNameLetterSpacing = '0.0';
    let moNameLineHeight = 12;
    let moNameSpaceBelow = 0;
    let moNotesLetterSpacing = '0.0';
    let moNotesLineHeight = 12;
    let moNotesSpaceBelow = 0; 
    let extrasMarginTop = 0;
    let betweenPrices = 0.5;

    if (props.menuObjectStyles.name && props.menuObjectStyles.name['line-height']) {
      nameLineHeight = (parseFloat(props.menuObjectStyles.name['line-height']) || 1) * 10;
    }
    if (props.menuObjectStyles.bin && props.menuObjectStyles.bin['line-height']) {
      binLineHeight = (parseFloat(props.menuObjectStyles.bin['line-height']) || 1) * 10;
    }
    if (props.menuObjectStyles.name && props.menuObjectStyles.name['letter-spacing']) {
      nameLetterSpacing = util.formatLetterSpacing(props.menuObjectStyles.name['letter-spacing']);
    }
    if (props.menuObjectStyles.item) {
      itemMarginBottom = parseFloat(props.menuObjectStyles.item['margin-bottom']) * 10;
      itemLineHeight = parseFloat(props.menuObjectStyles.item['line-height']) * 10;
    }
    if (props.menuObjectStyles.extras && props.menuObjectStyles.extras['margin-top']) {
      extrasMarginTop = parseFloat(props.menuObjectStyles.extras['margin-top']) * 10;
    }
    if (props.menuObjectStyles['price-entry'] && props.menuObjectStyles['price-entry']['margin-right']) {
      betweenPrices = parseFloat(props.menuObjectStyles['price-entry']['margin-right']);
    }
    if (props.menuObjectStyles['mo-name'] && props.menuObjectStyles['mo-name']['letter-spacing']) {
      moNameLetterSpacing = util.formatLetterSpacing(props.menuObjectStyles['mo-name']['letter-spacing']);
    }
    if (props.menuObjectStyles['mo-name'] && props.menuObjectStyles['mo-name']['line-height']) {
      moNameLineHeight = Math.round(parseFloat(props.menuObjectStyles['mo-name']['line-height']) * 10);
    }
    if (props.menuObjectStyles['mo-name'] && props.menuObjectStyles['mo-name']['margin-bottom']) {
      moNameSpaceBelow = Math.round((parseFloat(props.menuObjectStyles['mo-name']['margin-bottom'])) * 10);
    }
    if (props.menuObjectStyles['mo-notes'] && props.menuObjectStyles['mo-notes']['letter-spacing']) {
      moNotesLetterSpacing = util.formatLetterSpacing(props.menuObjectStyles['mo-notes']['letter-spacing']);
    }
    if (props.menuObjectStyles['mo-notes'] && props.menuObjectStyles['mo-notes']['line-height']) {
      moNotesLineHeight = Math.round(parseFloat(props.menuObjectStyles['mo-notes']['line-height']) * 10);
    }
    if (props.menuObjectStyles['mo-notes'] && props.menuObjectStyles['mo-notes']['margin-bottom']) {
      moNotesSpaceBelow = Math.round(parseFloat(props.menuObjectStyles['mo-notes']['margin-bottom']) * 10);
    }

    if (props.$element === null || Object.keys(props.menuObjectStyles).length === 0 || !MenuObject.isMenuObject(this.props.$element)) {
      return (
        <div className="menu-object-content mo-deselect-container">
          <h2 className="mo-deselect-title">Select menu text on your design</h2>
          <svg>
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#mo-with-prices-tab-icon"} />
          </svg>
        </div>
      );
    }

    return (
      <div className={'aside-mo-spacing-wrapper scroller'}>
        <div className="section-header">
          <span>Group Names</span>
          <div className={'to-all'}>
            <a className={'btn btn-sec-sml'} onClick={this.namesApplyToAll.bind(this)}>Apply to all</a>
          </div>
        </div>

        <ul className="slider-list">
          <li className="slider-item">
            <label className="font-spacing">Letter Spacing</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="0" max="10" step=".1"
                value={moNameLetterSpacing} onChange={(ev) => this.updateMOSpacing(ev, 'mo-name', 'letter-spacing', 2)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'mo-name', 'letter-spacing', 2)} />
            </div>
            <input className="value" type="number" min="0" max="10" step=".1" disabled="disabled" value={moNameLetterSpacing} />
          </li>
          <li className="slider-item">
            <label className="font-spacing">Line Height</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="10" max="30" step="1" value={moNameLineHeight} onChange={(ev) => this.updateMOSpacing(ev, 'mo-name', 'line-height', 2)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'mo-name', 'line-height', 2)} />
            </div>
            <input className="value" type="number" min="10" max="30" step="1" disabled="disabled" value={moNameLineHeight} />
          </li>
          <li className="slider-item">
            <label className="font-spacing">Space Below</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="-10" max="50" step="1" value={moNameSpaceBelow} onChange={(ev) => this.updateMOSpacing(ev, 'mo-name', 'margin-bottom', 1)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'mo-name', 'margin-bottom', 1)} />
            </div>
            <input className="value" type="number" min="-10" max="50" step="1" disabled="disabled" value={moNameSpaceBelow} />
          </li>
        </ul>

        <div className="section-header">
          <span>Notes</span>
          <div className={'to-all'}>
            <a className={'btn btn-sec-sml'} onClick={this.notesApplyToAll.bind(this)}>Apply to all</a>
          </div>
        </div>
        <ul class="slider-list">
          <li className="slider-item">
            <label className="font-spacing">Letter Spacing</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="0" max="10" step=".1"
                value={moNotesLetterSpacing} onChange={(ev) => this.updateMOSpacing(ev, 'mo-notes', 'letter-spacing', 2)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'mo-notes', 'letter-spacing', 2)} />
            </div>
            <input className="value" type="number" min="0" max="10" step=".1" disabled="disabled" value={moNotesLetterSpacing} />
          </li>
          <li className="slider-item">
            <label className="font-spacing">Line Height</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="10" max="30" step="1" value={moNotesLineHeight} onChange={(ev) => this.updateMOSpacing(ev, 'mo-notes', 'line-height', 2)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'mo-notes', 'line-height', 2)} />
            </div>
            <input className="value" type="number" min="10" max="30" step="1" disabled="disabled" value={moNotesLineHeight} />
          </li>
          <li className="slider-item">
            <label className="font-spacing">Space Below</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="-10" max="40" step="1" value={moNotesSpaceBelow} onChange={(ev) => this.updateMOSpacing(ev, 'mo-notes', 'margin-bottom', 1)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'mo-notes', 'margin-bottom', 1)} />
            </div>
            <div className="value">{moNotesSpaceBelow + 10}</div>
          </li>
        </ul>

        <div className="section-header">
          <span>Items</span>
          <div className={'to-all item-apply-all'}>
            <a className={'btn btn-sec-sml'} onClick={this.applyToAll.bind(this)}>Apply to all</a>
          </div>
        </div>

        <ul className="slider-list">
          <li className="slider-item">
            <label className="font-spacing">Letter Spacing</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="0" max="10" step=".1"
                value={nameLetterSpacing} onChange={(ev) => this.updateMOSpacing(ev, 'name', 'letter-spacing', 2)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'name', 'letter-spacing', 2)} />
            </div>
            <input className="value" type="number" min="0" max="10" step=".1" disabled="disabled" value={nameLetterSpacing} />
          </li>
          <li className="slider-item">
            <label className="font-spacing">Name Height</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="10" max="30" step="1" value={nameLineHeight} onChange={(ev) => this.updateMOSpacing(ev, 'name', 'line-height', 2)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'name', 'line-height', 2)} />
            </div>
            <input className="value" type="number" min="10" max="30" step="1" disabled="disabled" value={nameLineHeight} />
          </li>
          {props.menuObjectLayout.indexOf('bin') > -1 && 
          <li className="slider-item">
            <label className="font-spacing">BIN Height</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="10" max="50" step="1" value={binLineHeight} onChange={(ev) => this.updateMOSpacing(ev, 'bin', 'line-height', 2)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'bin', 'line-height', 2)} />
            </div>
            <input className="value" type="number" min="10" max="50" step="1" disabled="disabled" value={binLineHeight} />
          </li>}
          <li className="slider-item">
            <label className="font-spacing">Between Items</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="0" max="30" step="1" value={itemMarginBottom} onChange={(ev) => this.updateMOSpacing(ev, 'item', 'margin-bottom', 2)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'item', 'margin-bottom', 2)} />
            </div>
            <input className="value" type="number" min="0" max="30" step="1" disabled="disabled" value={itemMarginBottom} />
          </li>
          <li className="slider-item">
            <label className="font-spacing">Line Height</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="10" max="30" step="1" value={itemLineHeight} onChange={(ev) => this.updateMOSpacing(ev, 'item', 'line-height', 2)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'item', 'line-height', 2)} />
            </div>
            <input className="value" type="number" min="10" max="30" step="1" disabled="disabled" value={itemLineHeight} />
          </li>
          <li className="slider-item">
            <label className="font-spacing">Above Extras</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="0" max="30" step="1" value={extrasMarginTop} onChange={(ev) => this.updateMOSpacing(ev, 'extras', 'margin-top', 2)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'extras', 'margin-top', 2)} />
            </div>
            <input className="value" type="number" min="0" max="30" step="1" disabled="disabled" value={extrasMarginTop} />
          </li>
          <li className="slider-item">
            <label className="font-spacing">Between Prices</label>
            <div className="toolbar-wrap">
              <input className="slider" type="range" min="0.5" max="5" step=".1" value={betweenPrices} onChange={(ev) => this.updateMOSpacing(ev, 'price-entry', 'margin-right', 2, false)} onMouseMove={(ev) => this.updateMOSpacing(ev, 'price-entry', 'margin-right', 2, false)} />
            </div>
            <input className="value" type="number" min="0.5" max="5" step=".1" disabled="disabled" value={betweenPrices} />
          </li>
        </ul>
      </div>
    )
  }
}
